<div class="order-summary">
	<div *ngIf="configure_service.isStepEnabled('purchase_vehicle')" class="summary-section">
		<h2 class="heading">Your New Vehicle</h2>
		<div class="summary-item">
			<div class="label">
				<span *ngIf="vehicle.make">{{ vehicle.make }} </span>
				<span *ngIf="vehicle.model">{{ vehicle.model }} </span>
				<span *ngIf="vehicle.edition">{{ vehicle.edition }}</span>
			</div>
			<div class="value text-hl">
				{{ vehicle.price | money }}
				<small *ngIf="vehicle.add_vat">+ VAT</small>
			</div>
		</div>
	</div>
	<div *ngIf="configure_service.isStepEnabled('part_exchange') && part_exchanges.length" class="summary-section">
		<h2 class="heading">Part Exchange</h2>
		<ng-template ngFor [ngForOf]="part_exchanges" let-p>
			<div class="summary-item">
				<div class="label">
					<span *ngIf="p.registration !== null">{{ p.registration }} - </span>
					<span *ngIf="p.vehicle.make || p.vehicle.model">{{ p.vehicle.make }} {{ p.vehicle.model }} </span>
					<span *ngIf="p.vehicle.edition">{{ p.vehicle.edition }}</span>
				</div>
				<div class="value text-hl">
					<div *ngIf="p.vehicle.allowance !== null">{{ -p.vehicle.allowance | money }}</div>
					<div *ngIf="p.vehicle.allowance === null"><small>Awaiting valuation</small></div>
				</div>
			</div>
			<div *ngIf="p.vehicle.finance_settlement" class="summary-item">
				<div class="label">Finance Settlement Amount</div>
				<div class="value text-hl">
					{{ p.vehicle.finance_settlement | money }}
				</div>
			</div>
		</ng-template>
	</div>
	<div *ngIf="configure_service.isStepEnabled('customise_review') && selected_addons.length" class="summary-section">
		<h2 class="heading">Add-ons &amp; Fees</h2>
		<div *ngFor="let addon of selected_addons" class="summary-item">
			<div class="label">{{addon.description}}</div>
			<div class="value text-hl">
				{{addon.amount | money}}
				<small *ngIf="vehicle.add_vat && addon.vat">+ VAT</small>
			</div>
		</div>
	</div>
	<div *ngIf="configure_service.isStepEnabled('finance_options')" class="summary-section">
		<h2 class="heading">Finance Options</h2>
		<div class="summary-item">
			<div class="label">Payment Method:</div>
			<div class="value text-hl">
				{{finance_meta.available && finance_meta.enabled && !force_cash_payment ? 'Finance' : 'Cash'}}
			</div>
		</div>
	</div>

	<div *ngIf="configure_service.isStepEnabled('delivery_options') && handover.date" class="summary-section">
		<h2 class="heading">{{handover.type === 1 ? 'Collection' : 'Delivery'}} Details</h2>

		<div class="summary-item">
			<div class="label">{{handover.type === 1 ? 'Collection' : 'Delivery'}} Address</div>
			<div class="value text-hl">
				<span *ngIf="handover.type === 1" [innerHtml]="collection_address || dealer.address"></span>
				<span *ngIf="handover.type !== 1" [innerHtml]="delivery_address"></span>
			</div>
		</div>
		<div class="summary-item">
			<div class="label">Preferred Date / Time</div>
			<div class="value text-hl">
				{{ handover.date | date: 'EEEE dd/MM/yyyy' }} - {{ (handover.date | date: 'H') === '10' ? 'Morning' : 'Afternoon' }}
			</div>
		</div>
	</div>
	<div *ngIf="vehicle.add_vat || show_totals" class="summary-section">
		<h2 class="heading">Totals</h2>
		<div *ngIf="vehicle.add_vat" class="summary-item">
			<div class="label">Sub Total (Ex. VAT)</div>
			<div class="value text-hl">{{ grand_total_net | money }}</div>
		</div>
		<div *ngIf="vehicle.add_vat" class="summary-item">
			<div class="label">VAT Amount</div>
			<div class="value">{{ grand_total_vat | money }}</div>
		</div>
		<div class="summary-item">
			<div class="label">Grand Total</div>
			<div class="value text-hl">{{ grand_total | money }}</div>
		</div>
	</div>
</div>
